import {
  AvatarInput,
  Separator,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUploadCompanyLogoById } from 'src/hooks/companies/upload-company-logo.hook';
import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';
import { useGetGantts } from 'src/hooks/gantts/get-gantts.hook';
import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';

import { HeaderContainer } from './company.styles';
import { CompanyEdit } from './components/company-edit';
import { CompanyInfo } from './components/company-info';
import { CompanyGantts } from './components/company-gantts';

const Company = () => {
  const [logoUrl, setLogoUrl] = useState<string | undefined>();
  const [isEdit, setIsEdit] = useState(false);
  const { t } = useTranslation('settings');

  const { company } = useGetCurrentCompany();
  const { member } = useGetCurrentMemberAccount();

  const uploadCompanyLogoById = useUploadCompanyLogoById();

  const { gantts } = useGetGantts();
  const allowedGanttIds = member?.ganttsAccess.map((doc: any) => doc.ganttId);
  const allowedGantts = gantts.filter((gantt: any) => allowedGanttIds.includes(gantt._id));

  useEffect(() => {
    if (company) {
      setLogoUrl(company.logoUrl);
    }
  }, [company]);

  const onAvatarInputChange = (value: any) => {
    uploadCompanyLogoById({ variables: { logo: value, companyId: company._id } }).then(
      ({ data }: any) => setLogoUrl(data.uploadCompanyLogoById.logoUrl)
    );
  };

  return (
    <>
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('company.labels.logo')}
        </Typography>
        <AvatarInput
          avatar={logoUrl}
          onChange={onAvatarInputChange}
          btnText={logoUrl ? t('common:buttons.reloadLogo') : t('common:buttons.uploadLogo')}
        />
      </HeaderContainer>
      <Separator />
      {isEdit ? (
        <CompanyEdit
          onCancelEdit={() => setIsEdit(false)}
          companyData={{ ...company, ownerCompany: member.ownerCompany }}
        />
      ) : (
        <CompanyInfo
          onClickEdit={() => setIsEdit(true)}
          companyData={{ ...company, ownerCompany: member.ownerCompany }}
        />
      )}
      <Separator />
      <CompanyGantts gantts={allowedGantts} companyId={company._id} member={member} />
    </>
  );
};

export default Company;
